// core/pwa.js — registro do service worker (Fase 11).
//
// Regras:
//   - Só registra em produção (import.meta.env.PROD). Em dev, o Vite
//     ficaria em conflito com HMR e cache quente do SW.
//   - Só registra em contextos seguros (HTTPS ou localhost) — browsers
//     rejeitam SW em HTTP puro por segurança.
//   - Em caso de atualização, avisa via console. Poderia virar toast no
//     futuro (notify.info 'Nova versão disponível — recarregue').
//
// Exporta:
//   registerPWA() — chamado pelo main.js após o boot.

export function registerPWA() {
  if (!('serviceWorker' in navigator)) {
    console.info('[pwa] service worker não suportado neste navegador');
    return;
  }

  if (!import.meta.env.PROD) {
    console.info('[pwa] modo dev — service worker não registrado');
    return;
  }

  // `load` evita competir com recursos críticos do boot
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' })
      .then(reg => {
        console.info('[pwa] service worker registrado', reg.scope);

        // Detecta atualização: novo SW baixado mas aguardando para ativar
        reg.addEventListener('updatefound', () => {
          const incoming = reg.installing;
          if (!incoming) return;
          incoming.addEventListener('statechange', () => {
            if (incoming.state === 'installed' && navigator.serviceWorker.controller) {
              console.info('[pwa] nova versão disponível — recarregue para aplicar');
              // Futuramente: disparar toast via notify.info() com ação "Atualizar".
            }
          });
        });
      })
      .catch(err => {
        console.warn('[pwa] falha ao registrar service worker:', err);
      });
  });
}
